var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 2,
    viewBox: "0 0 16 2",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minus_svg__7---Review-Survey",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus_svg__7_3_1---Review-Survey---Multiple-Chice---Input",
    transform: "translate(-1478 -663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus_svg__Add-Queations",
    transform: "translate(295 296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus_svg__Question",
    transform: "translate(24 224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus_svg__Answer",
    transform: "translate(0 120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus_svg__Minus",
    transform: "translate(1152 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus_svg__Icon-/-Minus-16px",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus_svg__Icon-/Plus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus_svg__Icon-/Minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "minus_svg__Path",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11h14a1 1 0 010 2H5a1 1 0 010-2z",
    id: "minus_svg__Rectangle",
    fill: "#3F6DB4"
  }))))))))))));
}
export default SvgMinus;